// ** 경기 설정 유틸리티 **

// event: 145M, 90M, 70M, 30M
// 과녁마다 2개 조가 경기

// event에 따라 조당 선수 수 결정
export const getPlayersPerGroup = (event) => {
  // 145M: 조당 7명
  // 90M, 70M, 30M: 조당 2명
  return event === "145" ? 7 : 2;
};

// event에 따라 과녁 개수 결정
export const getTargetCount = (date, event) => {
  const distance = event.replace("M", "");

  switch (date) {
    case "2025-11-01":
    case "2025-11-02":
      return distance === "145" ? 6 : 18;

    case "2025-11-03":
      return distance === "145" ? 6 : 16;

    case "2025-11-04":
      return 4;

    default:
      return 0;
  }
};